import { useState } from "react";
import { Upload, X, Loader2, Paperclip } from "lucide-react";
import { apiClient } from "@/lib/api";

export default function FileUploadField({ files, onChange, testId = "file-upload" }) {
  const [uploading, setUploading] = useState(false);

  const handleChange = async (e) => {
    const selected = Array.from(e.target.files || []);
    if (!selected.length) return;
    setUploading(true);
    try {
      const uploaded = [];
      for (const file of selected) {
        const formData = new FormData();
        formData.append("file", file);
        const res = await apiClient.post("/upload", formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        uploaded.push({ path: res.data.path, filename: res.data.filename });
      }
      onChange([...(files || []), ...uploaded]);
    } catch (err) {
      console.error("Erreur d'envoi de fichier", err);
    } finally {
      setUploading(false);
      e.target.value = "";
    }
  };

  const removeFile = (path) => {
    onChange((files || []).filter((f) => f.path !== path));
  };

  return (
    <div>
      <label
        htmlFor={testId}
        data-testid={testId}
        className="flex items-center justify-center gap-2 border-2 border-dashed border-navy/20 rounded-xl px-4 py-6 text-sm font-medium text-navy/70 cursor-pointer hover:border-orange transition-colors"
      >
        {uploading ? <Loader2 className="w-4 h-4 animate-spin" /> : <Upload className="w-4 h-4" />}
        {uploading ? "Envoi en cours..." : "Ajouter des photos ou vidéos (optionnel)"}
        <input
          id={testId}
          type="file"
          accept="image/*,video/*"
          multiple
          className="hidden"
          onChange={handleChange}
          disabled={uploading}
        />
      </label>
      {files?.length > 0 && (
        <div className="flex flex-wrap gap-2 mt-3" data-testid={`${testId}-list`}>
          {files.map((f) => (
            <span
              key={f.path}
              className="flex items-center gap-1.5 bg-graylight rounded-full px-3 py-1 text-xs font-medium text-navy"
            >
              <Paperclip className="w-3 h-3" /> {f.filename}
              <button type="button" onClick={() => removeFile(f.path)} aria-label="Supprimer le fichier">
                <X className="w-3 h-3" />
              </button>
            </span>
          ))}
        </div>
      )}
    </div>
  );
}
